import { ReactNode, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import { IconButton } from "../IconButton";
import { useNextT } from "../../i18n";

export type MenuItemDef = { label: string; icon?: ReactNode; onSelect: () => void; danger?: boolean; disabled?: boolean } | "divider";

/** The ⋯ menu: rarer and destructive actions (DESIGN_SYSTEM: "everything rarer goes under ⋯"). */
export const KebabMenu = ({ label, items }: { label?: string; items: MenuItemDef[] }) => {
  const { t } = useNextT();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <IconButton label={label ?? t("ui.more_actions")} icon={<MoreVertRoundedIcon />} aria-haspopup="menu" aria-expanded={!!anchor} onClick={(e) => { e.stopPropagation(); setAnchor(e.currentTarget); }} />
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)} className="cy-next" onClick={(e) => e.stopPropagation()}>
        {items.map((it, i) => it === "divider" ? <Divider key={`d${i}`} /> : (
          <MenuItem key={it.label} disabled={it.disabled} onClick={() => { setAnchor(null); it.onSelect(); }}
            sx={{ minHeight: 48, color: it.danger ? "var(--cy-error)" : "var(--cy-heading)", fontFamily: "var(--cy-font)" }}>
            {it.icon && <ListItemIcon sx={{ color: "inherit" }} aria-hidden>{it.icon}</ListItemIcon>}
            {it.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
